import { render } from "./HTML0000.vue?vue&type=template&id=12271d37&scoped=true"
import script from "./HTML0000.vue?vue&type=script&lang=js"
export * from "./HTML0000.vue?vue&type=script&lang=js"

import "./HTML0000.vue?vue&type=style&index=0&id=12271d37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12271d37"]])

export default __exports__